import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export interface ActiveOrganization {
  id: string;
  name: string;
  is_test: boolean | null;
}

export const useActiveOrganization = () => {
  const { activeOrganizationId } = useAuth();

  return useQuery({
    queryKey: ['active-organization', activeOrganizationId],
    queryFn: async () => {
      if (!activeOrganizationId) return null;

      const { data, error } = await supabase
        .from('organizations')
        .select('id, name, is_test')
        .eq('id', activeOrganizationId)
        .single();

      if (error) throw error;
      return data as ActiveOrganization;
    },
    enabled: !!activeOrganizationId,
    staleTime: 5 * 60 * 1000,
  });
};